export default __webpack_public_path__ + "static/media/fowl.a6d19f12.mp3";